module.exports = __webpack_public_path__ + "static/media/3.08916d1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/units/unused icon/3.svg
// module id = 421
// module chunks = 14